import {h, Fragment} from "preact"
import { useFacet } from "@nosto/preact"

export default function Facet({ facet }) {
    const { toggleProductFilter } = useFacet(facet)

    return (
        <div className="ns-facet">
            <div
                className="ns-facet__header"
                data-nosto-element="facet"
            >
                {facet.name}
            </div>
            <div className="ns-facet__body">
                <ul className={`ns-facet__filters-list ns-m-0 ${(facet.name === 'Size') ? "sizes-list" : ""}`}>
                    {facet.data?.map(value => (   
                        <li
                            className="ns-facet__filters-item"
                            data-nosto-element="facet-setting"
                            key={value.value}
                        >
                            <label className="ns-checkbox">
                                <input
                                    className="visually-hidden"
                                    type="checkbox" 
                                    checked={value.selected}
                                    onChange={e => {
                                        e.preventDefault()
                                        toggleProductFilter(facet.field, value.value, !value.selected)
                                    }}
                                />
                                <span aria-hidden="true">{value.value}</span>
                                <span className="sr-only">{value.value} ({value.count})</span>
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
